//
import Service from '@/services/api/service'
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

/**
 * This class describes a pch purchase order.
 *
 * @class      PchPurchaseOrder (name)
 */
export default class PchPurchaseOrder extends Service {

  /**
   * Return the pch purchase order resource.
   *
   * @return     {Object}  The pch purchase order model
   */
  resource() {
    return PurchaseOrderModel
  }

  /**
   * Returns a pch purchase order list.
   *
   * @return     {Object}  The pch purchase order list request.
   */
  toList() {
    return this
      .append('')
      .include(
        //'g_authorizer_user.hr_employee',
        'g_originator_user.hr_employee',
        //'pch_detail_purchase_orders.wh_product',
        //'pch_detail_purchase_orders.wh_product_service',
        //'pch_payment_condition',
        'pch_provider',
        //'pch_provider_branch_offices',
        //'pch_purchase_order_has_invoice_numbers.pch_purchase_invoice',
        'pch_purchase_order_state',
        //'wh_orderers.g_supervisor_user',
        //'wh_orderers.pch_provider',
        //'wh_orderers.pch_provider_branch_offices',
        //'wh_product_receptions',
        //'wh_warehouse.g_branch_office.g_commune',
      )
  }

  /**
   * Returns a pch purchase order list.
   *
   * @return     {Object}  The pch purchase order list request.
   */
  toEmittedList() {
    return this
      .append('')
      .include(
        //'g_authorizer_user.hr_employee',
        'g_originator_user.hr_employee',
        'pch_detail_purchase_orders',
        //'pch_detail_purchase_orders.wh_product',
        //'pch_detail_purchase_orders.wh_product_service',
        //'pch_payment_condition',
        'pch_provider',
        //'pch_provider_branch_offices',
        //'pch_purchase_order_has_invoice_numbers.pch_purchase_invoice',
        'pch_purchase_order_state',
        //'wh_orderers.g_supervisor_user',
        //'wh_orderers.pch_provider',
        //'wh_orderers.pch_provider_branch_offices',
        //'wh_product_receptions',
        //'wh_warehouse.g_branch_office.g_commune',
      )
  }
}
